import { useCallback } from "react";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

/**
 * SKU를 클립보드에 복사하고 결과를 토스트로 알린다.
 * 상품 카드와 등록 신청 내역 모달들이 같은 동작을 쓰므로 한 곳에 모아둔다.
 */
export default function useCopySku() {
  const { t } = useI18nHelper();
  const { info, error } = useAppToasts();

  const copySku = useCallback(
    async (sku: string | null | undefined) => {
      // 복사할 값이 없으면 토스트도 띄우지 않는다.
      if (!sku) {
        return;
      }
      try {
        await navigator.clipboard.writeText(sku);
        info(t("path_pick:search_products.product_list.card.sku_copied"));
      } catch (err) {
        // clipboard API는 비보안 컨텍스트/권한 거부 시 throw한다.
        error(err);
      }
    },
    [t, info, error]
  );

  return { copySku };
}
